import { merge, set } from 'lodash';
import { TInputState, TSubmitFormData } from '../types';
import { TBaseDataItem } from '../../../../types';

export const constructSubmitData = (
  inputs: Record<string, TInputState>,
  values?: TSubmitFormData
): Record<string, TBaseDataItem | Blob> => {
  const data: TSubmitFormData = {};
  for (const [path, input] of Object.entries(inputs)) {
    if (input.touched) set(data, path, input.value);
  }
  return merge(data, values);
};
